export default class ABTestHelper {
    /**
     * Retrieve the test version cookie and format the data
     * {
     *     testVersionCookie
     * }
     *
     * @static
     * @param {any} reduxStore
     * @returns
     *
     * @memberOf ABTestHelper
     */

    static saveCookie(name, value, days, domain = '.jcpenney.com') {
        let expires;
        const date = new Date();
        if (days) {
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toGMTString()}`;
        } else {
            expires = '';
        }
        document.cookie = `${name}=${value}${expires};domain=${domain};path=/`;
    }

    static removeCookie(name, domain = '.jcpenney.com') {
        if (name) {
            const expires = `=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${domain};path=/`;
            document.cookie = name + expires;
        }
    }

    static getABTestData(testVersion, fromClient) {
        const data = [];
        // TODO: FeatureFlags should be checked before loading AB Test engagements
        if (testVersion) {
            if (fromClient) {
                ABTestHelper.saveCookie('testVersion', testVersion);
            }

            // testVersion = 'JABXXX: RWD: OrganicSearch: SOLR : UsrSeg=abc123'
            testVersion
                .replace(/\s/g, '')
                .split(',')
                .some((abTest) => {
                    const values = abTest.split(':');
                    data.push({
                        testNumber: values[0] || '', // Eg: JABXXX
                        channel: values[1] || '', // Eg: RWD
                        testType: values[2] || '', // Eg: OrganicSearch
                        platform: values[3] || '', // Eg: Endeca
                        userSegments: (values[4] || '').split('=')[1] || '', // Eg: UsrSeg=abc123
                        abTest,
                    });
                    return false;
                });
        } else if (fromClient) {
            ABTestHelper.removeCookie('testVersion');
        }

        return data;
    }
}
